/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkout_Add_Address_PromptInputs */

const en_checkout_add_address_prompt = /** @type {(inputs: Checkout_Add_Address_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add delivery address to continue`)
};

const es_checkout_add_address_prompt = /** @type {(inputs: Checkout_Add_Address_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añade una dirección de entrega para continuar`)
};

const fr_checkout_add_address_prompt = /** @type {(inputs: Checkout_Add_Address_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajoutez une adresse de livraison pour continuer`)
};

const de_checkout_add_address_prompt = /** @type {(inputs: Checkout_Add_Address_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lieferadresse hinzufügen, um fortzufahren`)
};

const id_checkout_add_address_prompt = /** @type {(inputs: Checkout_Add_Address_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tambahkan alamat pengiriman untuk melanjutkan`)
};

/** @type {(inputs: Checkout_Add_Address_PromptInputs) => LocalizedString} */
const ja_checkout_add_address_prompt = en_checkout_add_address_prompt;

/** @type {(inputs: Checkout_Add_Address_PromptInputs) => LocalizedString} */
const zh_checkout_add_address_prompt = en_checkout_add_address_prompt;

/** @type {(inputs: Checkout_Add_Address_PromptInputs) => LocalizedString} */
const ar_checkout_add_address_prompt = en_checkout_add_address_prompt;

/** @type {(inputs: Checkout_Add_Address_PromptInputs) => LocalizedString} */
const it_checkout_add_address_prompt = en_checkout_add_address_prompt;

/** @type {(inputs: Checkout_Add_Address_PromptInputs) => LocalizedString} */
const ru_checkout_add_address_prompt = en_checkout_add_address_prompt;

/** @type {(inputs: Checkout_Add_Address_PromptInputs) => LocalizedString} */
const pt_checkout_add_address_prompt = en_checkout_add_address_prompt;

/** @type {(inputs: Checkout_Add_Address_PromptInputs) => LocalizedString} */
const ko_checkout_add_address_prompt = en_checkout_add_address_prompt;

/**
* | output |
* | --- |
* | "Add delivery address to continue" |
*
* @param {Checkout_Add_Address_PromptInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const checkout_add_address_prompt = /** @type {((inputs?: Checkout_Add_Address_PromptInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkout_Add_Address_PromptInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_checkout_add_address_prompt(inputs)
	if (locale === "es") return es_checkout_add_address_prompt(inputs)
	if (locale === "fr") return fr_checkout_add_address_prompt(inputs)
	if (locale === "de") return de_checkout_add_address_prompt(inputs)
	if (locale === "ja") return ja_checkout_add_address_prompt(inputs)
	if (locale === "zh") return zh_checkout_add_address_prompt(inputs)
	if (locale === "ar") return ar_checkout_add_address_prompt(inputs)
	if (locale === "id") return id_checkout_add_address_prompt(inputs)
	if (locale === "it") return it_checkout_add_address_prompt(inputs)
	if (locale === "ru") return ru_checkout_add_address_prompt(inputs)
	if (locale === "pt") return pt_checkout_add_address_prompt(inputs)
	return ko_checkout_add_address_prompt(inputs)
});